import React, { Component } from "react";

import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Grid,
  Tooltip,
} from "@material-ui/core";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import FlagIcon from "@material-ui/icons/Flag";

import { makeStyles, } from "@material-ui/core/styles";

import gameService from "../../services/game-service";

const useStyles = makeStyles((theme) => ({
  teamSeed: {
    marginLeft: theme.spacing(1),
    marginTop: "1px",
    fontSize: "11px",
    width: "11px",
    color: "#999"
  },
  teamName: {
    flexGrow: 1,
    marginLeft: theme.spacing(0.5),
    fontSize: "12px",
  },
}));

const TeamRow = (props) => {
  const classes = useStyles();
  const {
    team,
    score,
    isTeam1,
    handleScoreChange,
  } = props;

  const {
    name,
    abbreviation,
    seed,
    icon_path,
  } = team;

  return (
    <Box
      display="flex"
      alignItems="center"
    >
      {icon_path && (
        <img
          src={`/assets/icons/${icon_path}`}
          height={16}
          width={16}
        />
      )}
      <Typography
        className={classes.teamSeed}
        align={"right"}
      >
        {seed}
      </Typography>
      <Typography
        className={classes.teamName}
      >
        {name}
      </Typography>
      <TextField
        value={score}
        type={"number"}
        variant="filled"
        size="small"
        onChange={(event) => handleScoreChange(event, isTeam1)}
      />
    </Box>
  );
};

class AdminGameEntry extends Component {
  constructor(props) {
    super(props);

    const {
      team1Score,
      team2Score,
    } = props.game;

    this.state = {
      team1Score: team1Score,
      team2Score: team2Score,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event, isTeam1) {
    let score = event.target.value;

    if (score !== "") {
      score = parseFloat(score);
    } 

    if (isTeam1) {
      this.setState({
        team1Score: score,
      });
    } else {
      this.setState({
        team2Score: score,
      });
    }
  }

  onSaveClick = async () => {
    const {
      game,
      openSnackbar,
    } = this.props;

    const {
      team1Score,
      team2Score,
    } = this.state;

    const updatedGame = {
      ...game,
      team1Score: team1Score,
      team2Score: team2Score,
    };

    await gameService.updateGame(updatedGame, openSnackbar);
  }

  render() {
    const {
      game,
      team1,
      team2,
    } = this.props;

    const {
      team1Score,
      team2Score,
    } = this.state;

    const { isComplete, period } = game;
    const isFinal = period === "FINAL";
    const readyToScore = isFinal && !isComplete;
    const saveDisabled = !isFinal && !isComplete;

    let statusIcon;
    if (isComplete) {
      statusIcon = (
        <Tooltip title="Scored">
          <CheckCircleIcon style={{ color: "green" }} />
        </Tooltip>
      );
    } else if (readyToScore) {
      statusIcon = (
        <Tooltip title="Ready to score">
          <FlagIcon style={{ color: "orange" }} />
        </Tooltip>
      );
    } else {
      statusIcon = (
        <Tooltip title="Game not finished">
          <CancelIcon style={{ color: "red" }} />
        </Tooltip>
      );
    }

    return (
      <Box m={2}>
        <Paper>
          <Box p={2}>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>
                <TeamRow
                  team={team1}
                  score={team1Score}
                  isTeam1
                  handleScoreChange={this.handleChange}
                />
                <TeamRow
                  team={team2}
                  score={team2Score}
                  handleScoreChange={this.handleChange}
                />
              </Box>
              <Box display="flex" alignItems="center" ml={2}>
                <Button variant="outlined" onClick={this.onSaveClick} disabled={saveDisabled}>
                  Score game
                </Button>
                <Box ml={1}>
                  {statusIcon}
                </Box>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    );
  }
}

export default(AdminGameEntry);
